/* ============================================================
   GYAANSTORE — ₹ BRIDGE FOR THE CART (assets/gs-cart-currency.js)
   Loaded once site-wide in layout/theme.liquid (defer).

   WHY (plain language):
   The whole storefront shows the ₹ sign, but the shop's money format is still
   "Rs. {{amount}}". The native cart drawer / add-to-cart popup AND the Essential
   upsell app's free-shipping + reward bars print prices straight from that money
   format, so they show "Rs." and look inconsistent with the ₹ everywhere else.

   This is a TEMPORARY, theme-scoped bridge: it swaps "Rs." -> "₹" only inside the
   cart UI (drawer / notification / the app's bars) as they render. The permanent
   single-source fix is to set the shop money format to ₹ at publish time — once
   that's done, this file becomes a harmless no-op and can be removed.

   Safety: only swaps "Rs" when it is immediately followed by a digit (i.e. a price),
   so ordinary text that happens to contain "Rs" is never touched.
   ============================================================ */
(function () {
  var PRICE_RS = /Rs\.?\s?(?=\d)/g;   // "Rs.", "Rs ", "Rs" before a number
  var RUPEE = '₹';

  // Walk the text nodes of a container and fix any "Rs<number>" -> "₹<number>".
  function fixText(root) {
    if (!root || !root.nodeType) return;
    try {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue && t.nodeValue.indexOf('Rs') !== -1 && PRICE_RS.test(t.nodeValue)) {
          PRICE_RS.lastIndex = 0;
          t.nodeValue = t.nodeValue.replace(PRICE_RS, RUPEE);
        }
        PRICE_RS.lastIndex = 0;
      }
    } catch (e) {}
  }

  // The cart surfaces we care about (native + the upsell app's injected bars).
  function cartTargets() {
    var list = [];
    var ids = ['CartDrawer'];
    ids.forEach(function (id) { var el = document.getElementById(id); if (el) list.push(el); });
    var sels = ['cart-drawer', 'cart-notification',
                '[class*="essential"]', '[class*="upsell"]',
                '[class*="free-ship"]', '[class*="freeship"]', '[class*="reward"]', '[class*="goal"]'];
    sels.forEach(function (s) {
      try { document.querySelectorAll(s).forEach(function (el) { if (list.indexOf(el) === -1) list.push(el); }); } catch (e) {}
    });
    return list;
  }

  function run() { cartTargets().forEach(fixText); }

  // Debounce to once per animation frame so we never thrash, even if the app
  // re-renders its bar rapidly.
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { pending = false; run(); }, 16);
  }

  function init() {
    run();
    // Re-run when our own cart events fire (add / refresh)...
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:refresh', schedule);
    // ...and when Dawn re-renders the drawer or the app injects/updates its bars.
    // childList only (not characterData) so our own text edits don't re-trigger us.
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
